import React from 'react';

const ReadField = (props) => (
    <div className="field-container">
        <label className="field-placeholder font-medium">{props.label}</label>
        <p 
          className="txtReadOnly fieldReadOnly textWrap" 
          disabled={props.disabled ? props.disabled : false}
        >
          {props.value}
        </p>
      </div>
  )


export default ReadField;